import { Flex } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const LoaderWrapper = styled(Flex, { shouldForwardProp: (prop) => prop !== 'isLoading' })<{
  isLoading?: boolean
}>`
  display: ${({ isLoading }) => (isLoading ? 'flex' : 'none')};
  height: 100%;
  padding-top: 16px;

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  background-color: ${theme.token.var('colors.green.a25')};
`
